import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-package-add',
  standalone: true,
  templateUrl: '../../assets/package-add.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPackageAddIcon {}
